import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponentComponent } from '../components/home-component/home-component.component';
import { WINDOW_PROVIDERS } from '../providers/window-providers.service';
import { HeaderComponentComponent } from '../components/header-component/header-component.component';
import { OrganizationComponent } from '../components/organization/organization.component';
import { SkillsComponent } from '../components/skills/skills.component';
import { ProjectComponent } from '../components/organization/project/project.component';
import { ContactComponent } from '../components/contact/contact.component';
import { HttpClientModule } from '@angular/common/http'

import {firebaseConfig} from "../environments/firebase.config";
import { AngularFireModule } from 'angularfire2';
import {AngularFireDatabase} from "angularfire2/database-deprecated";
import { AboutmeComponent } from '../components/aboutme/aboutme.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponentComponent,
    HeaderComponentComponent,
    OrganizationComponent,
    SkillsComponent,
    ProjectComponent,
    ContactComponent,
    AboutmeComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFireModule,
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [WINDOW_PROVIDERS, AngularFireDatabase],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts